module.exports = __webpack_public_path__ + "static/media/guest_list-white-bg.8553f76a.svg";